<template>
    <div class="site__body">
        <div class="block-header block-header--has-breadcrumb block-header--has-title">
            <div class="container">
                <div class="block-header__body">
                    
                    <div class="flexbox-page-info-container">
                        <div class="flex-item-page-info-breadcrumbs">
                            <nav class="breadcrumb block-header__breadcrumb block-header__breadcrumb-bottom-adjust" aria-label="breadcrumb">
                                <ol class="breadcrumb__list">
                                    <li class="breadcrumb__spaceship-safe-area" role="presentation"></li>
                                    <li class="breadcrumb__item breadcrumb__item--parent breadcrumb__item--first">
                                        <router-link to="/" class="breadcrumb__item-link">Home</router-link>
                                    </li>							                                
                                    <li class="breadcrumb__item breadcrumb__item--current breadcrumb__item--last" aria-current="page">
                                        <span class="breadcrumb__item-link">Categories</span>
                                    </li>								                               
                                    <li class="breadcrumb__title-safe-area" role="presentation"></li>
                                </ol>
                            </nav>
                        </div>
                        
                        <div class="flex-item-page-info-title">
                            <h1 class="block-header__breadcrumb-slim">Categories</h1>
                        </div>
                        <base-selected-vehicle></base-selected-vehicle>
                        
                    </div>			                     
                                                    
                                            
                </div>
            </div>
            
        </div>
        <div class="block block-split block-split--has-sidebar">
            <div class="container">
                <div class="block-split__row row no-gutters">
                    <div class="block-split__item block-split__item-sidebar col-auto">
                        <product-categories @filter_subcat="setSubcat"></product-categories>
                        <faceted-panel></faceted-panel>
                        <latest-products></latest-products>
                    </div>
                    <div class="block-split__item block-split__item-content col-auto">
                        <category-grid></category-grid>
                        <div class="block-space block-space--layout--divider-nl"></div>
                        <div class="block-space block-space--layout--divider-thin"></div>
                        <featured-products :sliderPerPage='4' ></featured-products>                
                        <div class="block-space block-space--layout--divider-nl"></div>
                            <!-- <div class="block-space block-space--layout--divider-nl"></div> -->
                            <!-- <suggested-products></suggested-products> -->
                        <!-- <suggested-swiper></suggested-swiper> -->
                    </div>
                </div>
                <div class="block-space block-space--layout--before-footer"></div>
            </div>
        </div>
    </div>  
        
</template>

<script>
import LatestProducts from "../productdetail/LatestProducts";
import ProductCategories from "../productdetail/ProductCategories";
// import SelectedVehicle from "../productdetail/SelectedVehicle";
// import SuggestedProducts from "../productdetail/SuggestedProducts";
import CategoryGrid from "./CategoryGrid";
import FacetedPanel from "./FacetedPanel";
import FeaturedProducts from "../home/Featured";
// import SuggestedSwiper from "../productdetail/SuggestedSwiper";

export default {
    name: "Category",
    components: {
        LatestProducts,
        ProductCategories,
        // SelectedVehicle,
        // SuggestedProducts,
        CategoryGrid,
        FeaturedProducts,
        FacetedPanel
    },

    created() {
        this.$ga.page({
            page: this.$route.fullPath,
            title: this.$route.name,
        });
        // console.log(this.$route.params);
    },

    methods: {
        
    }
};
</script>